import script from "./LosingProductNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./LosingProductNotification.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__